module.exports = __webpack_public_path__ + "static/media/NITRKL.f07897c9.png";